import axios from 'axios';

export default {
  getPortausCompany(id){
    let params = null;
    if (id != null) {
      params = {
        id,
      }
    };
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/portaus-companies", {params})
    .then(results=>{
      return results.data;
    })

   
  },
  updatePortausCompany(id, postData){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/portaus-companies/"+id, postData)
      .then(results=>{
        return results.data;
      })
  },
  generateToken(newPortausCompanyId) {
    const postData = {
      portausCompanyId: newPortausCompanyId,
    };
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/portaus-companies/token", postData)
      .then(results=>{
        return results.data;
      })
  },
  updateAgencyInformation(id, putData){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/portaus-companies/agencies/" + id, putData)
      .then(results=>{
        return results.data;
      })
  },
  fetchAgencyInformation(){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/portaus-companies/agencies")
      .then(results=>{
        return results.data;
      })
  },
}
